import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as fromDocument from '../../document/reducers';
import { SearchCriteria } from '../models/search-criteria';
import { Observable } from 'rxjs/Observable';
import { SearchResult } from '../models/search-result';
import * as actions from '../actions/search';
import { KvItem } from '../../core/models/kv-item';
import * as fromApp from '../../../app.reducer';

@Component({
  selector: 'app-search-results',
  template: `
  <irar-search-criteria [criteria]="searchCriteria$ | async" [resultCount]="resultCount$ | async"></irar-search-criteria>
  <div>
    To view a specific document, click on the Title.
  </div>
  <div>
    <irar-search-results
      [results]="results$ | async"
      [downloading]="downloading$ | async"
      [loggedIn]="loggedIn$ | async"
      (downloadFile)="download($event)"></irar-search-results>
  </div>
  `
})
export class SearchResultsContainerComponent {
  searchCriteria$: Observable<SearchCriteria>;
  resultCount$: Observable<number>;
  results$: Observable<SearchResult[]>;
  downloading$: Observable<boolean>;
  loggedIn$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>,
    private appStore: Store<fromApp.State>) {
    this.searchCriteria$ = this.store.select(fromRoot.getSearchCriteria);
    this.resultCount$ = this.store.select(fromRoot.getSearchResultCount);
    this.results$ = this.store.select(fromRoot.getSearchResults);
    this.downloading$ = this.store.select(fromRoot.getSearchLoading);
    this.loggedIn$ = this.appStore.select(fromApp.getAuthIsAdmin);

  }

  download(e: KvItem) {
    this.store.dispatch(new actions.DownloadFileAction(e));
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/search-results.ts